export const enToobar = {
    translation : {
        "Agregar nueva conversación": "Add new conversation",
        "Agregar un número de teléfono": "Add a phone number",
        'uno':'one',
        '¡El usuario ha sido creado! ahora estás hablando con':'User created! Now you are talking with',
        'El usuario Existe!':'User exist!',
    }
}